declare global {
  interface Window {
    __RPSO_CONFIG__?: { metricaId: number | null };
  }
}

export const getCounterId = (): number | null =>
  typeof window === 'undefined' ? null : (window.__RPSO_CONFIG__?.metricaId ?? null);

/** Подписка + повторное чтение snapshot в React покрывают оба порядка загрузки скриптов. */
export const subscribeCounterId = (notify: () => void): (() => void) => {
  const script = document.getElementById('site-config');
  if (!script) return () => {};
  script.addEventListener('load', notify);
  script.addEventListener('error', notify);
  return () => {
    script.removeEventListener('load', notify);
    script.removeEventListener('error', notify);
  };
};

// Пререндер и первый проход гидратации не зависят от runtime-конфига сервера.
export const getServerCounterId = (): null => null;
